import { i18n } from "@lingui/core"
import { t } from "@lingui/macro"
import { Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import React from "react"
import clsx from "clsx"
import { useSuitePricesLoader } from "../../app-core/v3/_common/machines/ecommerce-machine/data-loading/suite-prices-loader-machine"
import useSanityContent from "../../app-core/_common/hooks/use-sanity-content"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { suitesComparisonContentQuery } from "../../app-core/_common/sanity/sanity-queries"
import { SanitySuitesComparisonModalQueryResponse, toSanityLocale } from "../../app-core/_common/sanity/sanity-types"
import PageSpinner from "../PageSpinner/PageSpinner"
import { useIsTabletOrDesktop } from "../ResponsiveComponents"
import useModal from "../ModalProvider/useModal"
import styles from "./SuitesComparisonModal.module.scss"

import SuitesComparisonLoaded from "./SuitesComparisonLoaded"

type Props = {
    targetSuiteCategory?: string
}
const SuitesComparisonModal: React.FC<React.PropsWithChildren<Props>> = ({ targetSuiteCategory }) => {
    const [state] = useECommerceMachine()
    const [stateSP] = useSuitePricesLoader(state)
    const isTableOrDesktop = useIsTabletOrDesktop()
    const { closeModal } = useModal()
    const { locale, sanityContent } = state.context
    const shipVersionKey = state.context.suitesSanity[0].shipVersionKey
    const shipId = sanityContent.cruiseData.ship._id

    const sanityLang = toSanityLocale(locale)
    const { isLoading, data: allSuitesContent } = useSanityContent<SanitySuitesComparisonModalQueryResponse>(
        `suites-comparison-modal-content`,
        suitesComparisonContentQuery,
        { shipId: shipId, shipVersionKey: shipVersionKey },
        sanityLang,
    )

    const isPriceLoading = !stateSP.matches("loaded")

    return (
        <Modal
            title={i18n._(t`Suites Comparison`)}
            modal={{ isOpen: true, onRequestClose: () => closeModal("closeWithCallback") }}
            size="fullscreen"
            dataContentName={`modal_suites_comparison`}
        >
            <ModalBody
                variant="wide"
                paddingTop={false}
                paddingBottom
                className={clsx(styles.modalBody, { [styles.extended]: isTableOrDesktop })}
            >
                {isPriceLoading || isLoading || !allSuitesContent ? (
                    <PageSpinner />
                ) : (
                    <>
                        <SuitesComparisonLoaded
                            variant={isTableOrDesktop ? "extended" : "compact"}
                            suitesContent={allSuitesContent}
                            allPrices={stateSP.context.response.prices}
                            targetSuiteCategory={targetSuiteCategory}
                            SuitesComparisonSelectButton={
                                state.context.flowVersion.ui.suiteCategory.SuitesComparisonButton
                            }
                        />
                    </>
                )}
            </ModalBody>
        </Modal>
    )
}

export default SuitesComparisonModal
